import React from 'react';
import PropTypes from 'prop-types';
import { REGEX_PASSWORD } from '../../toolbox/regex';
import i18n from '../../config/i18n';

class ResetForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordInputValue: '',
      confirmPasswordInputValue: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onPasswordInputChange = this.onPasswordInputChange.bind(this);
    this.onConfirmPasswordInputChange = this.onConfirmPasswordInputChange.bind(this);
  }

  onPasswordInputChange() {
    this.setState({ passwordInputValue: this.passwordInput.value });
  }

  onConfirmPasswordInputChange() {
    this.setState({ confirmPasswordInputValue: this.confirmPasswordInput.value });
  }

  onSubmit(e) {
    e.preventDefault();
    return this.props.updatePassword(this.state.passwordInputValue);
  }

  render() {
    const passwordMatch = this.state.passwordInputValue === this.state.confirmPasswordInputValue;
    const passwordMeetsRequirement = REGEX_PASSWORD.test(this.state.passwordInputValue);
    const confirmPasswordHelpBlockText = passwordMatch ? '' : i18n.t('pwdNotMatch');
    const passwordHelpBlockText = passwordMeetsRequirement ? '' : i18n.t('pwdFormat');

    return (
      <form onSubmit={this.onSubmit}>
        <div className="form-group">
          <label className="control-label" htmlFor="password">
            {i18n.t('newPwd')}
          </label>
          <input
            id="passwordInput"
            className="form-control"
            type="password"
            value={this.state.passwordInput}
            ref={(input) => { this.passwordInput = input; }}
            onChange={this.onPasswordInputChange}
            required
          />
          <span className="help-block text-danger">{passwordHelpBlockText}</span>
        </div>
        <div className="form-group">
          <label className="control-label" htmlFor="confirm-password">
            {i18n.t('newPwdConfirm')}
          </label>
          <input
            id="confirm-password"
            className="form-control"
            type="password"
            value={this.state.confirmPasswordInput}
            ref={(input) => { this.confirmPasswordInput = input; }}
            onChange={this.onConfirmPasswordInputChange}
            required
          />
          <span className="help-block text-danger">{confirmPasswordHelpBlockText}</span>
        </div>
        <div className="form-group clearfix">
          <button
            className="btn btn-primary pull-right"
            disabled={!passwordMatch || !passwordMeetsRequirement}
          >
            {i18n.t('resetPwd')}
          </button>
        </div>
      </form>
    );
  }
}

ResetForm.propTypes = {
  updatePassword: PropTypes.func.isRequired,
};

export default ResetForm;



// WEBPACK FOOTER //
// ./src/components/login/ResetForm.js